var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hkl-external-link-icon",
      class: { "hkl-external-link-icon--disabled": _vm.disabled },
    },
    [
      _c(
        "i",
        _vm._g(
          _vm._b(
            { class: ["fa", "fa-external-link", { pointer: !_vm.disabled }] },
            "i",
            _vm.$attrs,
            false
          ),
          _vm.disabled ? {} : _vm.$listeners
        )
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }